import { render, staticRenderFns } from "./LogoutForm.vue?vue&type=template&id=6246e28a&"
import script from "./LogoutForm.vue?vue&type=script&lang=ts&"
export * from "./LogoutForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports